import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: '<router-outlet><ngx-ui-loader></ngx-ui-loader></router-outlet>'
})
export class AppComponent implements OnInit {
  constructor(private router: Router,private ngxService: NgxUiLoaderService) { }

  ngOnInit() {
  
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });

  }
}
